import { localizePhoneNumbers } from '@lucid/gatsby-theme-lucid';
import React, { useContext } from 'react';

import LayoutContext from '../../contexts/layoutContext';
import {
  Drupal_ParagraphCtaButton,
  Drupal_ParagraphMarketoForm,
  Drupal_ParagraphOrCallCta
} from '../../generated/graphql';
import Link from '../link/link';
import './pre-footer-cta.scss';
import useMarketoLink from '../../hooks/use-marketo-link';

interface Props {
  header?: string | null;
  subheader?: string | null;
  pitch?: string | null;
  ctas?: Drupal_ParagraphCtaButton[] | null;
  orCallCta?: Drupal_ParagraphOrCallCta | null;
  theme?: 'dark' | 'light';
}

const PreFooterCta = (props: Props) => {
  const { language } = useContext(LayoutContext);
  const { header, subheader, pitch, ctas, orCallCta, theme = 'dark' } = props;
  const isPhoneNumber = /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im;
  const getMarketoLink = useMarketoLink(language);

  return (
    <div className={`pre-footer-cta ${`pre-footer-cta--${theme}`}`}>
      <div className="pre-footer-cta__content">
        {header && (
          <h2 className="pre-footer-cta__header">
            {isPhoneNumber.test(header) ? (
              <Link
                className="pre-footer-cta__header-link"
                to={localizePhoneNumbers(`tel:+1${header}`)}
              >
                {localizePhoneNumbers(header)}
              </Link>
            ) : (
              localizePhoneNumbers(header)
            )}
          </h2>
        )}

        {subheader && <p className="pre-footer-cta__subheader">{subheader}</p>}

        {pitch && <p className="pre-footer-cta__pitch">{pitch}</p>}

        <div className="pre-footer-cta__ctas">
          {ctas &&
            ctas.map(
              ({
                fieldButtonLink,
                fieldButtonText,
                fieldIsSecondary,
                fieldMarketo
              }) => {
                const marketoForm = fieldMarketo
                  ? (fieldMarketo.entity as Drupal_ParagraphMarketoForm)
                  : null;
                if (fieldButtonLink) {
                  return (
                    <Link
                      key={fieldButtonText!}
                      to={fieldButtonLink}
                      primary={!fieldIsSecondary}
                      secondary={!!fieldIsSecondary}
                      asButton
                      className="pre-footer-cta__cta-link"
                    >
                      {fieldButtonText}
                    </Link>
                  );
                }
                if (marketoForm) {
                  const { url, copy } = getMarketoLink(
                    marketoForm.fieldMarketoId
                  )!;
                  return (
                    <Link
                      to={url}
                      asButton
                      key={fieldButtonText!}
                      primary={!fieldIsSecondary}
                      secondary={!!fieldIsSecondary}
                      className="pre-footer-cta__button-test"
                    >
                      {fieldButtonText || copy}
                    </Link>
                  );
                }
                return;
              }
            )}

          {orCallCta && (
            <Link
              className="pre-footer-cta__ctas-phone-link"
              to={`tel:+1${orCallCta.fieldCallCtaPhoneNumber}`}
            >
              {orCallCta.fieldCallCtaText}
              {orCallCta.fieldCallCtaPhoneNumber}
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default PreFooterCta;
